"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const cookie = tslib_1.__importStar(require("cookie"));
const abtests_1 = tslib_1.__importDefault(require("../abtests"));
const parseTestsFromCookies = (cookieString) => {
    return (0, abtests_1.default)(cookie.parse(cookieString));
};
exports.default = parseTestsFromCookies;
//# sourceMappingURL=parse-tests-from-cookies.js.map